import styled from 'styled-components';

export const TitleBar = styled.div`
  border-bottom: 1px solid #dddddd;
  background-color: #fafafa;
  padding: 15px 20px;
  font-size: 15px;
  border: 1px solid #dddddd;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  border-bottom: none;
  align-items: center;
  justify-content: space-between;
  display: flex;
  font-weight: bold;
`;
export const Container = styled.div`
  background-color: white;
  border: 1px solid #dddddd;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
`;
export const Chart = styled.div`
  margin: 0 20px 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  align-content: space-between;
`;
export const Row = styled.div`
  margin: 15px 20px 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  @media screen and (max-width: 595px) {
    flex-direction: column;
  }
`;
export const Col = styled.div`
  margin: 15px 20px 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;
export const Select = styled.select`
  width: ${props => props.theme.width || '70px'};
  margin-left: 7px;
  margin-right: 7px;
  height: 30px;
  border: 1px solid #999999;
  border-radius: 8px;
`;
export const LegendBar = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-content: center;
  width: 78%;

  @media screen and (max-width: 736px) {
    flex-direction: column;
  }
`;
export const Table = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-self: center;
  width: 100%;
`;
export const TableHead = styled.div`
  background-color: #fafafa;
  display: flex;
`;
export const TableBody = styled.div`
  height: 90px;
  overflow: auto;
  border: 1px solid #dddddd;
  border-top: none;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
`;
export const InnerTable = styled.div`
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  padding: 5px 4px; //5px 7px;
  border-bottom: 1px solid #dddddd;
  &:last-child {
    border-bottom: none;
  }
  &:hover {
    background: #ededed;
  }
`;
export const OtherDetail = styled.div`
  align-self: flex-end;
  margin: 15px;
  @media screen and (max-width: 595px) {
    margin-top: 25px;
  }
`;
export const VisibleButton = styled.div`
  display: block;
  border: 1px solid #e0e0e0;
  border-right: none;
  border-top-left-radius: 4px;
  flex: 7%;
  text-align: center;
  padding: 4px;
  color: #aaa;
  cursor: pointer;
  &:hover {
    color: #3498db;
  }
`;
export const TableTitle = styled.div`
  display: block;
  flex: 93%;
  padding: 6px 10px;
  font-size: 12px;
  font-weight: bold;
  align-self: center;
  cursor: pointer;
  border: 1px solid #e0e0e0;
  border-top-right-radius: 4px;
  &:hover {
    > div {
      color: #3498db;
    }
  }
  > div {
    color: #aaa;
    display: inline-block;
    margin-left: 10px;
  }
`;
export const Wrapper = styled.div`
  width: 600px;
  @media screen and (max-width: 736px) {
    width: auto;
  }
`;
